var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "fill-height" },
    [
      _c(
        "v-row",
        { attrs: { justify: "center", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8", md: "6" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(" У вас нет доступа ")]),
                  _c("v-card-subtitle", [
                    _vm._v(
                      " Для участия в закупка вы должны состоять в группе! "
                    ),
                  ]),
                  _c("v-card-text", { staticClass: "text-center" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "v-avatar",
                          { attrs: { size: "150" } },
                          [
                            _c("v-img", {
                              attrs: { src: _vm.auth_info.profile_image },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" Вы авторизовались как"),
                    _c("br"),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.auth_info.user.first_name) +
                          " " +
                          _vm._s(_vm.auth_info.user.last_name)
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "my-2" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn",
                            attrs: { small: "", color: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.goTo(_vm.auth_info.provider)
                              },
                            },
                          },
                          [_vm._v(" Сменить аккаунт ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a",
                      {
                        staticStyle: {
                          "text-decoration": "unset",
                          color: "gray",
                        },
                        on: { click: _vm.goToAuth },
                      },
                      [_vm._v(" Вернуться к авторизации ")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }